module.exports = __webpack_public_path__ + "img/insert_drive_file.b0021149.svg";